import service from '@/utils/services'
import storage from '@/utils/localStorage'
import utils from '@/utils/utils'

const isMobile = utils.isMobile()
const sourceChannel = utils.getQueryParam('source_channel')

const state = {
  isMobile: isMobile,
  sourceChannel: sourceChannel,
  staticUrl: window.staticUrl,
  language: window.language,
  gameUserinfo: {
    token: '',
    app_id: '',
    mobile: '',
    email: '',
    server_id: '',
    server_name: '',
    role_id: '',
    role_name: '',
    timezone: ''
  },
  info: {
    token: '',
    app_id: '',
    mobile: '',
    email: '',
    server_id: '',
    server_name: '',
    role_id: '',
    role_name: '',
    timezone: ''
  },
  feedbackQueryStr: ''
}

const getters = {
  isMobile: state => state.isMobile,
  sourceChannel: state => state.sourceChannel,
  staticUrl: state => state.staticUrl,
  language: state => state.language,
  gameUserinfo: (state) => {
    if (state.gameUserinfo.role_id === '' && state.gameUserinfo.token === '') {
      let gameUserinfo = storage.get('gameUserinfo')
      if (gameUserinfo !== null) {
        state.gameUserinfo = JSON.parse(gameUserinfo)
      }
    }
    return state.gameUserinfo
  },
  feedbackQueryStr: (state) => {
    if (state.feedbackQueryStr === '') {
      let feedbackQueryStr = storage.get('feedbackQueryStr')
      if (feedbackQueryStr !== null) {
        state.feedbackQueryStr = feedbackQueryStr
      }
    }
    return state.feedbackQueryStr
  }
}

const mutations = {
  updateGameUserinfo (state, params) {
    state.gameUserinfo = params
    storage.set('gameUserinfo', JSON.stringify(params))
  },
  feedbackQueryStr (state, string) {
    state.feedbackQueryStr = string
    storage.set('feedbackQueryStr', string)
  }
}

const actions = {
  getCustomPage ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.post('/customPage/get', params).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  getCustomPageList ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.post('/customPage/list', params).then((res) => {
        // console.log(res)
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  getComplaintHome ({ commit, state }) {
    return new Promise((resolve, reject) => {
      service.post('/customer/complaint/home', { app_id: state.gameUserinfo.app_id, token: state.gameUserinfo.token }).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else if (res.data.msg === 'token已过期,请重新登录') {
          commit('updateGameUserinfo',state.info)
          reject(res.data.msg)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  getCustomerRobotList ({ commit, state }, params) {
    params.app_id =  state.gameUserinfo.app_id
    params.token =  state.gameUserinfo.token
    params.status =  1
    return new Promise((resolve, reject) => {
      service.post('/customer/robot/list', params).then((res) => {
        // console.log(res)
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else if (res.data.msg==='token已过期,请重新登录') {
          commit('updateGameUserinfo',state.info)
          reject(res.data.msg)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  getCustomerComplaintList ({ commit, state }, params) {
    params.app_id = state.gameUserinfo.app_id
    params.token = state.gameUserinfo.token
    return new Promise((resolve, reject) => {
      service.post('/customer/complaint/list', params).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else if (res.data.msg === 'token已过期,请重新登录') {
          commit('updateGameUserinfo',state.info)
          reject(res.data.msg)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  changeStatusCustomerComplaint ({ commit, state }, params) {
    params.status = 5
    params.token = state.gameUserinfo.token
    return new Promise((resolve, reject) => {
      service.post('/customer/complaint/changeStatus', params).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else if (res.data.msg==='token已过期,请重新登录') {
          commit('updateGameUserinfo',state.info)
          reject(res.data.msg)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  commitCustomerComplaint ({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      params.app_id = state.gameUserinfo.app_id
      params.token = state.gameUserinfo.token
      params.server_id = state.gameUserinfo.server_id
      params.server_name = state.gameUserinfo.server_name
      params.role_id = state.gameUserinfo.role_id
      params.role_name = state.gameUserinfo.role_name
      params.timezone = state.gameUserinfo.timezone
      service.post('/customer/complaint/commit', params).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else if (res.data.msg==='token已过期,请重新登录') {
          commit('updateGameUserinfo',state.info)
          reject(res.data.msg)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  replyCustomerComplaint ({ commit, state }, params) {
    params.token = state.gameUserinfo.token
    params.type = 2
    params.read_status = 1
    return new Promise((resolve, reject) => {
      service.post('/customer/complaint/reply', params).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else if (res.data.msg==='token已过期,请重新登录') {
          commit('updateGameUserinfo',state.info)
          reject(res.data.msg)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  detailCustomerComplaint ({ commit, state }, params) {
    params.app_id = state.gameUserinfo.app_id
    params.token = state.gameUserinfo.token
    return new Promise((resolve, reject) => {
      service.post('/customer/complaint/detail', params).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else if (res.data.msg==='token已过期,请重新登录') {
          commit('updateGameUserinfo',state.info)
          reject(res.data.msg)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}

